import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ModalV2 } from "components/V2/atoms/ModalV2/ModalV2";
import { fetchSpecialfaresContent } from "../../dataLayer/cms";
import style from "./Booking.module.css";

interface SpecialFaresModalProps {
  specialFareDialog: boolean;
  closeSpecialFareDialog: () => void;
}

function SpecialFaresModal({ specialFareDialog, closeSpecialFareDialog }: SpecialFaresModalProps) {
  const [specialFare, setSpecialFare]: any = useState();
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleActiveTab = (index: number) => {
    setActiveTab(index);
  };

  useEffect(() => {
    async function displaySpecialFarePopup() {
      const specialcontent = await fetchSpecialfaresContent();
      const specialFares = specialcontent?.filter(
        (item) => item?.content === "specialFares"
      );
      setSpecialFare(specialFares);
    }
    displaySpecialFarePopup();
  }, []);

  return (
    <ModalV2
      isOpen={specialFareDialog}
      onClose={closeSpecialFareDialog}
      className={style.MainDialog}
      aria-labelledby={specialFare?.[0].title}
      modalTitle={specialFare?.[0].title}
      modalWidth="auto"
      showBorderRadius={true}
      contentStyle={{
        borderRadius: "12px 0 12px 12px",
        boxShadow:"none"
      }}
    >
      <Box className={style.mainBox}>
        <Box className={`${style.sf_flex} scrollbar-hidden`}>
          <hr />
          {specialFare?.[0]?.listItems?.map((item, index: number) => (
            <button
              className={`font-semibold text-xs py-2 px-4 text-center text-typography-secondary rounded-2xl whitespace-nowrap ${
                activeTab === index
                  ? `border-typography-tertiary border text-typography-tertiary`
                  : `bg-background-highlight-purple shadow-xs`
              }`}
              onClick={() => handleActiveTab(index)}
              type="button"
              role="tab"
              key={item?.label?.toLowerCase()}
            >
              {item?.label}
            </button>
          ))}
        </Box>
        <p className="text-sm mt-6 text-typography-primary font-normal">
          {specialFare?.[0]?.listItems?.[activeTab]?.content}
        </p>
      </Box>
    </ModalV2>
  );
}

export default SpecialFaresModal;
